module.exports = __webpack_public_path__ + "img/elevator_open02.1784b6fb.png";